module.exports = __webpack_public_path__ + "img/ios-settings.95705063.svg";